"use strict";

module.exports = {
  bindings: {
    formField: '=',
    required: '<',
    fieldName: '<',
    maxlength: '<'
  },
  template:
    '<text-angular ng-model="$ctrl.formField" editor-maxlength="{{$ctrl.maxlength}}" name="{{$ctrl.fieldName}}" ng-required="{{$ctrl.required}}" ta-text-editor-class="form-control editor-height" ta-html-editor-class="form-control editor-height"></text-angular>' +
    '<small ng-if="$ctrl.formField.length <= $ctrl.maxlength">{{$ctrl.formField.length}}/{{$ctrl.maxlength}} Zeichen (inkl. Formatierungen)</small>'
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/emil-editor.js